import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { errMsg } from "../admin/ui";
import { FAULTS } from "./shared";

const sel = "bg-[#191A1F] border border-[#35353B] text-[#F5F3ED] rounded-sm px-2 py-1.5 text-xs outline-none w-full";

export default function AllocationActions({ a, onDone }) {
  const [mode, setMode] = useState(null);
  const [fault, setFault] = useState(a.status === "cancel_requested" ? "external" : "supplier");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (path, body) => {
    setBusy(true);
    try { await api.post(`/allocations/${a.id}/${path}`, body); toast.success("Tersimpan"); setMode(null); setReason(""); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const open = ["committed", "cancel_requested"].includes(a.status);
  const btn = "text-[11px] font-bold rounded-sm px-2 py-1 border transition-colors";

  if (mode) return (
    <div data-testid={`alloc-action-form-${a.id}`} className="w-56 ml-auto space-y-1.5 text-left">
      {mode !== "reject" && <select data-testid={`alloc-fault-${a.id}`} value={fault} onChange={(e) => setFault(e.target.value)} className={sel}>
        {Object.entries(FAULTS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>}
      <input data-testid={`alloc-reason-${a.id}`} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Alasan (wajib, min. 5 karakter)" className={sel} />
      <div className="flex gap-1.5">
        <button data-testid={`alloc-confirm-${a.id}`} disabled={busy || reason.trim().length < 5}
          onClick={() => run(mode === "cancel" ? "cancel" : mode === "reject" ? "reject-cancel" : "correct-fault", mode === "reject" ? { reason } : { fault, reason })}
          className={`${btn} flex-1 bg-[#D4AF37] text-[#101114] border-[#D4AF37] disabled:opacity-40`}>Konfirmasi</button>
        <button onClick={() => setMode(null)} className={`${btn} border-[#35353B] text-[#A8A8AD]`}>Batal</button>
      </div>
    </div>
  );
  return (
    <div className="flex flex-wrap justify-end gap-1.5">
      {open && <button data-testid={`alloc-complete-${a.id}`} disabled={busy} onClick={() => window.confirm(`Tandai alokasi ${a.alloc_no} selesai? Reputasi supplier akan bertambah.`) && run("complete", { reason: "" })} className={`${btn} border-[#35C78A] text-[#35C78A] hover:bg-[#35C78A] hover:text-[#101114]`}>Selesai</button>}
      {open && <button data-testid={`alloc-cancel-${a.id}`} onClick={() => setMode("cancel")} className={`${btn} border-[#F06464] text-[#F06464]`}>{a.status === "cancel_requested" ? "Setujui Batal" : "Batalkan"}</button>}
      {a.status === "cancel_requested" && <button data-testid={`alloc-reject-${a.id}`} onClick={() => setMode("reject")} className={`${btn} border-[#35353B] text-[#F5F3ED]`}>Tolak Batal</button>}
      {a.status === "cancelled" && <button data-testid={`alloc-correct-${a.id}`} onClick={() => { setFault(a.fault === "supplier" ? "external" : "supplier"); setMode("correct"); }} className={`${btn} border-[#D4AF37] text-[#D4AF37]`}>{a.dispute?.status === "open" ? "Tinjau Sengketa" : "Koreksi"}</button>}
    </div>
  );
}
